import axios from 'axios'
import Cookie from 'js-cookie'

import apiAuth from '@/modules/api/methods/auth.js'
import apiQuestionnaire from '@/modules/api/methods/questionnaire'
import apiDevices from '@/modules/api/methods/devices'
import apiUsers from '@/modules/api/methods/user'
import apiSession from '@/modules/api/methods/session'
import apiCard from '@/modules/api/methods/card'
import apiVisit from '@/modules/api/methods/visit'
import apiAppointments from '@/modules/api/methods/appoitments'
import apiUser from '@/modules/api/methods/user'
import ApiLoyalty from '@/modules/api/methods/loyalty'
import apiDepartment from '@/modules/api/methods/department'
import apiDeviation from '@/modules/api/methods/deviation'
import apiMembership from '@/modules/api/methods/membership'
import apiProcedure from '@/modules/api/methods/procedure'
import apiStatistic from '@/modules/api/methods/statistic'
import apiHumanSystemHealth from '@/modules/api/methods/humanSystemHealth'
import apiComplexExercises from '@/modules/api/methods/complexExercises'
import apiDocuments from '@/modules/api/methods/documents'
import apiFiles from '@/modules/api/methods/files'
import apiDashboard from '@/modules/api/methods/dashboard'
import apiMarketProducts from '@/modules/api/methods/marketProducts'
import apiNeural from '@/modules/api/methods/neural'
import apiDynamics from '@/modules/api/methods/dynamics'
import apiMobileDevice from '@/modules/api/methods/mobileDevice'

export default {
    removeJWT() {

        Cookie.remove('access_token')
        Cookie.remove('refresh_token')
    },

    resetJWT(responseData) {
        let tokenExpires = responseData.expires_at;
        Cookie.set('access_token', responseData.access_token);
        Cookie.set('expires_token', new Date(tokenExpires).toUTCString());
    },

    clean(obj) {
        for (const propName in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if (!obj.hasOwnProperty(propName)) continue;
            if (obj[propName] === null || obj[propName] === undefined) {
                delete obj[propName];
            }
        }
    },

    trimCookie(cookie) {
        return cookie ? cookie.replace(/[А-Яа-я]/ig, "") : '';
    },

    setupInstance(store, router) {
        this.apiInstance = axios.create({
            baseURL: process.env.VUE_APP_ADMIN_API_BASE_URL,
            headers: {
                common: {
                    'Access': 'application/json',
                    'Accept-Language': 'ru',
                    'X-Requested-With': 'XMLHttpRequest',
                    'access-control-allow-origin': '*'
                }
            },
            mode: 'cors'
        })

        this.apiInstance.interceptors.request.use(async config => {

            if (Cookie.get('expires_token')) {
                let nowDate = new Date()
                let exDate = new Date(Cookie.get('expires_token'))

                if (nowDate >= exDate && router.history.current.name !== 'auth.signin') {

                    if (config.url !== '/doctor/auth/refresh')
                        await store.dispatch('auth/REFRESH_TOKEN')

                }
            }

            if (config.method === 'put' || config.method === 'post') {
                this.clean(config.data);
            }
            if (Cookie.get('access_token')) {
                config.headers.common['Authorization'] = `Bearer ${this.trimCookie(Cookie.get('access_token'))}`;
            }
            return config;
        }, async error => {
            return Promise.reject(error);
        });

        this.apiInstance.interceptors.response.use(async response => {
            return response;
        }, async (error) => {
            let code = 0;
            if (error.response)
                code = error.response.status
            if (code == 0) {
                this.app.notify.error({
                    title: "Ошибка передачи данных",
                    message: "Проверьте интернет соединение",
                })
            }
            if (code === 401 && router.history.current.name !== 'auth.signin') {
                console.log('error.response.config.url', error.response.config.url)

                if (error.response.config.url === '/doctor/auth/refresh') {

                    console.log('/doctor/auth/refresh', error.response.config.url)

                    await store.dispatch('auth/LOGOUT')
                    router.push({
                        name: 'auth.signin'
                    })
                } else {
                    console.log('auth/REFRESH_TOKEN')
                    await store.dispatch('auth/REFRESH_TOKEN')
                    console.log('auth/REFRESH_TOKEN2')

                }
            }
            return Promise.reject(error);
        })
    },

    install(Vue, store, router) {
        this.app = Vue.prototype
        this.setupInstance(store, router)

        const repositories = {
            auth: apiAuth(this.apiInstance),
            session: apiSession(this.apiInstance),
            appointments: apiAppointments(this.apiInstance),
            card: apiCard(this.apiInstance),
            visit: apiVisit(this.apiInstance),
            users: apiUsers(this.apiInstance),
            devices: apiDevices(this.apiInstance),
            questionnaire: apiQuestionnaire(this.apiInstance),
            user: apiUser(this.apiInstance),
            loyalty: ApiLoyalty(this.apiInstance),
            department: apiDepartment(this.apiInstance),
            documents: apiDocuments(this.apiInstance),
            deviation: apiDeviation(this.apiInstance),
            membership: apiMembership(this.apiInstance),
            procedure: apiProcedure(this.apiInstance),
            statistic: apiStatistic(this.apiInstance),
            humanSystemHealth: apiHumanSystemHealth(this.apiInstance),
            files: apiFiles(this.apiInstance),
            dashboard: apiDashboard(this.apiInstance),
            complexExercises: apiComplexExercises(this.apiInstance),
            marketProducts: apiMarketProducts(this.apiInstance),
            neural: apiNeural(this.apiInstance),
            dynamics: apiDynamics(this.apiInstance),
            mobileDevice: apiMobileDevice(this.apiInstance),
        };

        Vue.prototype.$api = repositories;
        Vue.prototype.$apiInstance = this.apiInstance;
        store.$api = repositories;
        store.resetJWT = this.resetJWT;
        store.removeJWT = this.removeJWT;
    },
};
